module.exports = __webpack_public_path__ + "img/skull_8_bj.c2b28068.png";